import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
var LoaderSvg = function LoaderSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "1"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0s",
    dur: "1.8s",
    values: "1; 20",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.165, 0.84, 0.44, 1",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    begin: "0s",
    dur: "1.8s",
    values: "1; 0",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.3, 0.61, 0.355, 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "1"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "-0.9s",
    dur: "1.8s",
    values: "1; 20",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.165, 0.84, 0.44, 1",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    begin: "-0.9s",
    dur: "1.8s",
    values: "1; 0",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.3, 0.61, 0.355, 1",
    repeatCount: "indefinite"
  }))));
};
LoaderSvg.defaultProps = {
  viewBox: "0 0 44 44",
  xmlns: "http://www.w3.org/2000/svg"
};
import getBorderColor from "../../../utils/getBorderColor";
import space from "../../../utils/space";
export var sizeSpaces = {
  nano: 2,
  // 16px
  tiny: 4,
  // 32px
  small: 6,
  // 48px
  medium: 12.5,
  // 100px
  big: 18.5 // 148px
};
export { sizeSpaces as loaderAtmSizeSpaces };
var StyledLoader = styled(LoaderSvg).withConfig({
  componentId: "sc-1vx1oi7-0"
})(function (_ref) {
  var $size = _ref.$size,
    $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["width:", ";height:", ";stroke:", ";"], space(sizeSpaces[$size]), space(sizeSpaces[$size]), getBorderColor(theme, $onColor, "high"));
});
function Loader(_ref2) {
  var size = _ref2.size;
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(StyledLoader, {
    $size: size,
    $onColor: onColor
  });
}
export default Loader;